export function CongressSenate(props: { height?: number; className?: string }) {
  const { className } = props

  const height = props.height ? props.height * 4 : 48
  const width = height * 1.25

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 32 40"
      version="1.1"
      xmlSpace="preserve"
      x="0px"
      y="0px"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      className={className}
      width={width}
      height={height}
    >
      <path d="M24.38,24c0,.28-.22.5-.5.5h-.46v.7c0,.28-.22.5-.5.5s-.5-.22-.5-.5v-1.2c0-.28.23-.5.5-.5h.96c.28,0,.5.22.5.5Z" />
      <path d="M27.38,24c0,.28-.22.5-.5.5h-.46v.7c0,.28-.22.5-.5.5s-.5-.22-.5-.5v-1.2c0-.28.23-.5.5-.5h.96c.28,0,.5.22.5.5Z" />
      <path d="M27.38,21.05c0,.27-.22.5-.5.5h-.46v.7c0,.28-.22.5-.5.5s-.5-.22-.5-.5v-1.2c0-.28.23-.5.5-.5h.96c.28,0,.5.22.5.5Z" />
      <path d="M24.38,21.05c0,.27-.22.5-.5.5h-.46v.7c0,.28-.22.5-.5.5s-.5-.22-.5-.5v-1.2c0-.28.23-.5.5-.5h.96c.28,0,.5.22.5.5Z" />
      <path d="M18.37,24c0,.28-.22.5-.5.5h-.46v.7c0,.28-.22.5-.5.5s-.5-.22-.5-.5v-1.2c0-.28.23-.5.5-.5h.96c.28,0,.5.22.5.5Z" />
      <path d="M21.37,24c0,.28-.22.5-.5.5h-.46v.7c0,.28-.22.5-.5.5s-.5-.22-.5-.5v-1.2c0-.28.23-.5.5-.5h.96c.28,0,.5.22.5.5Z" />
      <path d="M21.37,21.05c0,.27-.22.5-.5.5h-.46v.7c0,.28-.22.5-.5.5s-.5-.22-.5-.5v-1.2c0-.28.23-.5.5-.5h.96c.28,0,.5.22.5.5Z" />
      <path d="M18.37,21.05c0,.27-.22.5-.5.5h-.46v.7c0,.28-.22.5-.5.5s-.5-.22-.5-.5v-1.2c0-.28.23-.5.5-.5h.96c.28,0,.5.22.5.5Z" />
      <path d="M2.86,17.51v9.82c0,.27.23.5.5.5h24.92s0-1,0-1H3.86v-7.03h24.42s0-1,0-1H3.86v-.78h24.42s0-1.01,0-1.01H3.36c-.27,0-.5.23-.5.5Z" />
      <path d="M12.28,24c0,.28-.22.5-.5.5h-.46v.7c0,.28-.22.5-.5.5s-.5-.22-.5-.5v-1.2c0-.28.23-.5.5-.5h.96c.28,0,.5.22.5.5Z" />
      <path d="M15.28,24c0,.28-.22.5-.5.5h-.46v.7c0,.28-.22.5-.5.5s-.5-.22-.5-.5v-1.2c0-.28.23-.5.5-.5h.96c.28,0,.5.22.5.5Z" />
      <path d="M15.28,21.05c0,.27-.22.5-.5.5h-.46v.7c0,.28-.22.5-.5.5s-.5-.22-.5-.5v-1.2c0-.28.23-.5.5-.5h.96c.28,0,.5.22.5.5Z" />
      <path d="M12.28,21.05c0,.27-.22.5-.5.5h-.46v.7c0,.28-.22.5-.5.5s-.5-.22-.5-.5v-1.2c0-.28.23-.5.5-.5h.96c.28,0,.5.22.5.5Z" />
      <path d="M6.27,24c0,.28-.22.5-.5.5h-.46v.7c0,.28-.22.5-.5.5s-.5-.22-.5-.5v-1.2c0-.28.23-.5.5-.5h.96c.28,0,.5.22.5.5Z" />
      <path d="M9.27,24c0,.28-.22.5-.5.5h-.46v.7c0,.28-.22.5-.5.5s-.5-.22-.5-.5v-1.2c0-.28.23-.5.5-.5h.96c.28,0,.5.22.5.5Z" />
      <path d="M9.27,21.05c0,.27-.22.5-.5.5h-.46v.7c0,.28-.22.5-.5.5s-.5-.22-.5-.5v-1.2c0-.28.23-.5.5-.5h.96c.28,0,.5.22.5.5Z" />
      <path d="M6.27,21.05c0,.27-.22.5-.5.5h-.46v.7c0,.28-.22.5-.5.5s-.5-.22-.5-.5v-1.2c0-.28.23-.5.5-.5h.96c.28,0,.5.22.5.5Z" />{' '}
    </svg>
  )
}
